import styled from 'styled-components'
import { FormTxt } from 'atoms/Inputs'
import { ButtonReg } from 'atoms/Buttons'

export const SingleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 0.3;
  justify-content: center;
  width: 38%;
  margin-left: ${({ ml }) => (ml ? ml : '0')};
`

const SpinnerBtn = styled(ButtonReg)`
  display: flex;
  flex: 1;
  background-color: ${({ theme }) => theme.mocaPurple};
  border-radius: 0;
  justify-content: center;
  align-items: center;
  height: ${({ height }) => (height ? height : '34px')};
  color: ${({ theme }) => theme.white};

  &:hover:enabled {
    opacity: 0.9;
    cursor: pointer;
  };
`

export const LeftBtn = styled(SpinnerBtn)`
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
`

export const RightBtn = styled(SpinnerBtn)`
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
`

export const InputField = styled(FormTxt)`
  text-align: center;
  display: flex;
  width: 100%;
  border-color: ${({ theme }) => theme.mocaGrey};
  border-radius: 0;
  height: ${({ height }) => (height ? height : '34px')};
  padding: 9px 5px;
  flex: 2;
`
